'use client';

interface TextareaValueProps {
  value: string;
}

export function TextareaValue({ value }: TextareaValueProps) {
  return (
    <div className="whitespace-pre-wrap rounded-lg border border-border/40 bg-muted/30 p-3 text-xs font-medium leading-relaxed text-foreground dark:border-border/30 dark:bg-muted/20">
      {value}
    </div>
  );
}

